<!-- 员工状态 -->
<template>
  <el-form-item :label="label">
    <el-select
      v-model="typeList"
      :multiple="config.multiple"
      :placeholder="placeholder"
      :clearable="clearable"
    >
      <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-员工状态选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '员工状态：',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');

    const types = ref([
      {
        id: 1,
        name: '在职',
      },
      {
        id: 0,
        name: '离职',
      },
    ]);
    let typeList;
    function reset() {
      typeList.value = props.value;
    }

    typeList = useQuery('teacherStatusList', props.value, reset);

    return {
      reset,
      types,
      typeList,
    };
  },
};
</script>
